import React from 'react'

const RiskyConfigBannerDisabled: React.FC = () => null

export default RiskyConfigBannerDisabled
